import Vue from 'vue'
import Vuex from 'vuex'
import * as editor from '@/store/modules/editor.js'
import * as contributor from '@/store/modules/contributor.js'
import * as admin from '@/store/modules/admin.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
   
  },
  mutations: {

  },
  actions: {

  },
  modules: { 
    editor,
    contributor,
    admin
  }
})
